import { useDocumentTitle } from "@/hooks/use-document-title";
import { type FC } from "react";
import { Heading1 } from "@/components/podkit/typography/Headings";
import { useFlag } from "@/hooks/use-flag";
import { Flags } from "@/feature-flags";
import { Text } from "@/components/podkit/typography/Text";
import { RecentAgentExecutions } from "@/components/ai/RecentAgentExecutions";
import { OnaActions } from "@/components/ai/OnaActions";
import { PromptInput } from "@/components/ai/PromptInput";
import { Agents } from "@/queries/agent-queries";
export const OnaAIPage: FC = () => {
    useDocumentTitle("Ona AI");

    const { value: isFeatureEnabled, loading: isLoadingFeatureFlag } = useFlag(Flags.OnaAIEnabled, false);
    if (isLoadingFeatureFlag) {
        return;
    }

    return (
        <div data-testid="ona-ai-page" className="mx-auto flex max-w-[877px]">
            {!isFeatureEnabled && <OnaAINotEnabled />}
            {isFeatureEnabled && <OnaAIContents />}
        </div>
    );
};

const OnaAINotEnabled: FC = () => {
    return (
        <div data-testid="ona-ai-page-contents-disabled" className="flex flex-col items-center gap-6">
            <Heading1>Ona AI</Heading1>
            <Text className="text-center text-lg text-content-primary">Ona AI is not yet available to you.</Text>
        </div>
    );
};

const OnaAIContents: FC = () => {
    return (
        <div data-testid="ona-ai-page-contents" className="flex flex-col gap-12 overflow-x-hidden px-1">
            <div className="flex flex-col items-center gap-6">
                <Heading1>Ona AI</Heading1>
                <Text className="text-center text-lg text-content-primary">
                    Code problems solved, automatically. Simply describe your issue, and Ona AI generates complete,
                    ready-to-implement solutions. You focus on review while we handle the heavy lifting—accelerating
                    development without sacrificing quality. Build faster, innovate smarter.
                </Text>
                <PromptInput defaultAgentId={Agents.Ona.id} />
                <OnaActions />
            </div>
            <RecentAgentExecutions />
        </div>
    );
};
